let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gDiIK"), load("f1B4n"), load("eLlpV"), load("7iCpI")]).then(() => parcelRequire('e6TKr'));